import { useState } from "react";
import Tab from "./Tab";
import style from "./Tabs.module.css";
const Tabs = ({ children, defaultActiveTab }) => {
  const [activeTab, setActiveTab] = useState(
    defaultActiveTab ? defaultActiveTab : 0
  );
  return (
    <>
      <div className={style.tabHeader}>
        {children?.map((item, index) => (
          <Tab
            label={item?.props?.label}
            onClick={() => setActiveTab(index)}
            isActive={activeTab === index}
          />
        ))}
      </div>
      {children[activeTab]}
    </>
  );
};

export default Tabs;
